import * as THREE from 'three'
import { physicsToThree } from './scene.js'
import type { Hoop } from '../physics/hoop.js'

const HOOP_COLOR = 0xffffff
const HOOP_HEIGHT = 0.8   // visual height of uprights (taller = more visible from top-down)

export class HoopMesh {
  group: THREE.Group

  constructor(scene: THREE.Scene) {
    this.group = new THREE.Group()
    scene.add(this.group)
  }

  /** Position and orient the mesh to match a Hoop object. */
  update(hoop: Hoop): void {
    // Clear previous children
    while (this.group.children.length > 0) {
      this.group.remove(this.group.children[0])
    }

    const mat = new THREE.MeshLambertMaterial({ color: HOOP_COLOR })
    const r = hoop.uprightRadius

    // Left upright cylinder
    const leftGeo = new THREE.CylinderGeometry(r, r, HOOP_HEIGHT, 8)
    const leftMesh = new THREE.Mesh(leftGeo, mat)
    const leftPos = physicsToThree(hoop.left.x, hoop.left.y, HOOP_HEIGHT / 2)
    leftMesh.position.copy(leftPos)
    leftMesh.castShadow = true
    this.group.add(leftMesh)

    // Right upright cylinder
    const rightGeo = new THREE.CylinderGeometry(r, r, HOOP_HEIGHT, 8)
    const rightMesh = new THREE.Mesh(rightGeo, mat)
    const rightPos = physicsToThree(hoop.right.x, hoop.right.y, HOOP_HEIGHT / 2)
    rightMesh.position.copy(rightPos)
    rightMesh.castShadow = true
    this.group.add(rightMesh)

    // Crossbar connecting the tops
    const crossbarLength = hoop.gap + hoop.uprightRadius * 2
    const crossbarGeo = new THREE.CylinderGeometry(r * 0.8, r * 0.8, crossbarLength, 6)
    const crossbarMesh = new THREE.Mesh(crossbarGeo, mat)
    const centrePos = physicsToThree(hoop.centre.x, hoop.centre.y, HOOP_HEIGHT)
    crossbarMesh.position.copy(centrePos)
    // Rotate crossbar to lie horizontally, aligned with the upright pair
    const perpAngle = hoop.facing + Math.PI / 2
    crossbarMesh.rotation.z = Math.PI / 2
    crossbarMesh.rotation.y = -perpAngle
    crossbarMesh.castShadow = true
    this.group.add(crossbarMesh)
  }

  setVisible(visible: boolean): void {
    this.group.visible = visible
  }
}
